import { Component } from '@opten/compiler/metadata/component';
import { ComponentRef } from '@opten/compiler/metadata/di';
import { OnInit } from '@opten/compiler/metadata/lifecycle';
import getParentOrSelfWithClass from '@opten/dom/get-parent-or-self-with-class/index';
import { MenuCollapseComponent } from './menu-collapse';
import { SearchCollapseComponent } from './search-collapse';

@Component({ className: 'js-menu-buttons' })
export class MenuButtonComponent implements OnInit {
	onInit(): void {
		this.init();
	}

	private _mouseOnDetails = false;
	private _mouseOnList = false;
	private _isSearchOpen = false;
	private _isMenuOpen = false;

	private navigation: HTMLElement;

	@ComponentRef(MenuCollapseComponent) mobileDetailsCollapse: MenuCollapseComponent;
	@ComponentRef(SearchCollapseComponent) searchCollapse: SearchCollapseComponent;

	constructor(private element: HTMLElement) {}

	private init() {
		const navButtons = Array.from(this.element.getElementsByClassName('js-menu-button'));
		this.navigation = getParentOrSelfWithClass(this.element, 'navigation');
		const linkList = getParentOrSelfWithClass(this.element, 'navigation-items');
		const searchButtons = Array.from(this.navigation.getElementsByClassName('js-menu-search'));
		const hamburgerButton = this.navigation.getElementsByClassName('js-hamburger-mobile')[0];

		navButtons.forEach(navButton => {
			this.setNavButtonEventListeners(navButton);
		});

		// if navigation is transparent, add listener to the link list
		// which handle the class additions / removals
		if (this.navigation.classList.contains('is--transparent')) {
			linkList.addEventListener('mouseenter', () => {
				this._mouseOnList = true;
				this.navigation.classList.add('is--open');
			});

			linkList.addEventListener('mouseleave', () => {
				this._mouseOnList = false;
				// this.navigation.classList.remove('-open');
			});
		}

		// Add the search button listeners
		searchButtons.forEach(searchButton => {
			if (searchButton) {
				this.setSearchButtonEventListeners(searchButton);
			}
		});

		// add the mobile menu button listener. Closes search collapse if open
		if (hamburgerButton) {
			hamburgerButton.addEventListener('click', () => {
				this._isMenuOpen = !this._isMenuOpen;

				if (this.searchCollapse.collapse.isOpen()) {
					this._isSearchOpen = false;

					if (this.searchCollapse) {
						this.searchCollapse.collapse.hide();
					}
				}
			});
		}

		if (this.mobileDetailsCollapse) {
			this.mobileDetailsCollapse.element.addEventListener('hidden.opten.collapse', () => {
				if (this._isSearchOpen === false) {
					this.navigation.classList.remove('is--open');
				}
			});
		}

		if (this.searchCollapse) {
			this.searchCollapse.element.addEventListener('hidden.opten.collapse', () => {
				if (this._mouseOnList === false && this._isMenuOpen === false) {
					this.navigation.classList.remove('is--open');
				}
			});
		}
	}

	setNavButtonEventListeners(navButton: Element) {
		const target = navButton.attributes.getNamedItem('aria-controls');

		let navigationDetails: HTMLElement;

		if (target) {
			navigationDetails = document.getElementById(target.value);
		}

		if (navigationDetails) {
			navigationDetails.addEventListener('mouseenter', () => {
				if (this.searchCollapse.collapse.isOpen() === false) {
					this._mouseOnDetails = true;
					this.navigation.classList.add('is--open');
					navButton.classList.add('is--show-arrow');
				}
			});

			navigationDetails.addEventListener('mouseleave', () => {
				if (this.searchCollapse.collapse.isOpen() === false) {
					this._mouseOnDetails = false;
					navigationDetails.classList.remove('is--show');
					navButton.classList.remove('is--show-arrow');

					if (this._mouseOnList === false) {
						this.navigation.classList.remove('is--open');
					}
				}
			});

			navButton.addEventListener('mouseenter', () => {
				if (this.searchCollapse.collapse.isOpen() === false) {
					this.navigation.classList.add('is--open');
					navigationDetails.classList.add('is--show');
				}
			});
		}

		navButton.addEventListener('mouseleave', () => {
			setTimeout(() => {
				if (this.searchCollapse.collapse.isOpen() === false) {
					if (navigationDetails && this._mouseOnDetails === false) {
						navigationDetails.classList.remove('is--show');
					}

					if (this._mouseOnList === false && this._mouseOnDetails === false && this._isSearchOpen === false) {
						this.navigation.classList.remove('is--open');
					}
				}
			}, 1);
		});
	}

	setSearchButtonEventListeners(searchButton: Element) {
		const target = searchButton.attributes.getNamedItem('aria-controls');

		if (target) {
			const searchDiv = document.getElementById(target.value);

			if (searchDiv) {
				searchButton.addEventListener('click', event => {
					this._isSearchOpen = !this._isSearchOpen;

					if (this._isSearchOpen) {
						if (this.mobileDetailsCollapse) {
							this.mobileDetailsCollapse.collapse.hide();
							this._isMenuOpen = false;
						}

						this.navigation.classList.add('is--open');
						searchButton.classList.add('is--show-arrow');
					} else {
						searchButton.classList.remove('is--show-arrow');
					}
				});

				// Removes the white background of the navigation
				searchButton.addEventListener('mouseleave', () => {
					setTimeout(() => {
						const isNavigationMobileOpen = this.mobileDetailsCollapse.collapse.isOpen();
						if (this._isSearchOpen === false && this._mouseOnList === false && isNavigationMobileOpen === false) {
							this.navigation.classList.remove('is--open');
						}
					}, 1);
				});
			}
		}
	}
}
